var _path, _circle, _ellipse, _ellipse2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse3, _path14, _path15, _path16, _circle2, _path17, _polygon, _path18, _polygon2, _path19, _path20, _circle3, _polygon3, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle4, _path28, _path29, _path30, _circle5, _path31, _circle6, _ellipse4, _ellipse5, _path32, _line, _circle7, _path33, _line2, _circle8, _path34, _line3, _circle9, _path35, _path36, _circle10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappyloveBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 1061.30098,
    height: 814.40034,
    viewBox: "0 0 1061.30098 814.40034",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "intense feeling") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M647.08178,51.77909c-50.93658,13.2323-95.86584,48.55975-140.52362,94.90527a76.20054,76.20054,0,0,1-99.83508,115.0871c-52.45648,62.66449-109.734,128.91083-179.6413,183.663-177.9953,139.40814,188.04041,393.65545,420,393.65545s420.00006-176.24554,420.00006-393.65545S870.61425-6.29012,647.08178,51.77909Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#f2f2f2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 383.87955,
    cy: 157.20126,
    r: 54.31516,
    fill: "#ff6584"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 903.39443,
    cy: 711.65869,
    rx: 144.42094,
    ry: 18.74165,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 392.39443,
    cy: 795.65869,
    rx: 144.42094,
    ry: 18.74165,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M980.71007,689.20356s7.76033,26.73,12.93388,33.6281,9.48485,18.10744,6.89807,19.832-7.76033,22.41873-.86226,23.281,22.41873-22.41873,23.281-30.17906,4.3113-35.35262,4.3113-35.35262,6.03581-24.14325-3.449-25.86777-24.14325-2.58678-24.14325-2.58678Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M944.49519,717.65811s-11.20937,29.3168-13.79614,31.04132-12.07163,17.24518,6.89807,17.24518,29.3168-5.17355,29.3168-5.17355l6.03582-6.89808s0-18.10743-1.72452-20.69421,0-15.52066,0-15.52066Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M867.75414,449.49558s-13.79614,93.124-1.72451,123.303,24.14325,38.80165,24.14325,38.80165l91.39944,85.36363s28.45455-14.6584,25.86777-24.14325c0,0-6.03581-3.449-6.89807-6.03581s-12.07162-3.449-12.07162-3.449-5.17356-6.03581-5.17356-9.48484-44.83746-64.66942-59.49586-68.98072c0,0-7.76034-9.48485-6.89808-11.20937s-2.58677-7.76033-2.58677-7.76033l8.62259-33.62809,54.32231-8.62259s22.41873-79.32783,3.449-85.36364S867.75414,449.49558,867.75414,449.49558Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M975.53651,509.8537l1.72452,13.79615s0,36.21487-1.72452,39.66391-2.58677,8.62259,0,12.07162,6.89807,12.07163,5.17356,15.52066,3.449,100.8843-3.449,107.78237-4.31129,15.52066-3.449,16.38292-.86225,4.3113-.86225,4.3113-35.35262,6.03581-32.76584,0,2.58677-9.48485,4.31129-11.20937,0-4.31129,0-4.31129,2.58678-27.59229,0-29.31681-10.34711-84.50138-10.34711-85.36363-2.58677-2.58678-2.58677-6.03582,0-14.6584-4.3113-16.38292-3.449-43.9752-3.449-43.9752Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M914.31613,202.02726s3.449,25.86777,13.79614,31.04132,17.24518,7.76033,17.24518,7.76033L936.73486,271.008l-3.449,25.86776H893.62191l-21.55647-17.24518,6.89807-28.45454,3.449-5.17355s4.31129-18.9697.86226-25.00551S914.31613,202.02726,914.31613,202.02726Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#ffb9b9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M897.071,264.97216l6.03581,11.20937s4.3113-15.52066,10.34711-18.10744,20.69421-6.89807,20.69421-10.34711-.86226-12.07162,2.58678-12.07162,37.07713,10.34711,42.25069,13.79614,6.03581,6.89807,6.03581,6.89807l-9.48485,99.15978s13.79615,46.562,9.48485,64.66942-7.76033,20.69422-18.10744,23.281-4.31129-6.03581-34.49036,2.58678-49.14875,6.03581-56.04683,6.03581-11.20936,3.449-12.93388,4.3113-.86226-4.3113,5.17355-12.07163,3.449-20.69421,3.449-20.69421-6.89807-22.41873-2.58678-31.04132,10.34711-19.832,5.17356-23.281-12.07163-29.31681-12.07163-29.31681l-18.9697-67.2562,38.80166-26.73s-1.72452,12.07162,4.31129,14.6584S897.071,264.97216,897.071,264.97216Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#575a89"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M848.78445,271.87023h-5.17356s-8.62259,14.65841-8.62259,25.00551,4.3113,68.98072,4.3113,68.98072l25.00551,25.86777,6.03581-19.832,1.72452-43.9752Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#575a89"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M862.58059,363.26968s-28.45454-7.76033-27.59229,4.3113,5.17356,26.73,18.9697,30.17906,18.10744-15.52066,18.10744-15.52066S873.79,364.9942,862.58059,363.26968Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#575a89"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M969.5007,402.93359s-1.72452,39.66392-12.07163,43.97521l25.00551,6.03581s12.07163-41.38843,10.34711-43.11294S969.5007,402.93359,969.5007,402.93359Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#ffb9b9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M830.1728,317.032h16.15939a2.27559,2.27559,0,0,1,2.27559,2.27559v41.12367a2.77953,2.77953,0,0,1-2.77953,2.77953H830.67674a2.77953,2.77953,0,0,1-2.77953-2.77953V319.30755A2.27559,2.27559,0,0,1,830.1728,317.032Z",
    transform: "translate(-135.40846 321.20851) rotate(-23.59797)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M830.1728,317.032h16.15939a2.27559,2.27559,0,0,1,2.27559,2.27559v41.12367a2.77953,2.77953,0,0,1-2.77953,2.77953H830.67674a2.77953,2.77953,0,0,1-2.77953-2.77953V319.30755A2.27559,2.27559,0,0,1,830.1728,317.032Z",
    transform: "translate(-135.40846 321.20851) rotate(-23.59797)",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M830.67954,319.45777h14.08833a2.27559,2.27559,0,0,1,2.27559,2.27559V360.758a2.77953,2.77953,0,0,1-2.77953,2.77953H831.18348a2.77953,2.77953,0,0,1-2.77953-2.77953V321.73336a2.27559,2.27559,0,0,1,2.27559-2.27559Z",
    transform: "translate(-136.00363 321.11191) rotate(-23.59797)",
    fill: "#2f2e41"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 832.63807,
    cy: 335.52813,
    rx: 4.14211,
    ry: 4.19807,
    transform: "translate(-134.03922 318.57664) rotate(-23.59795)",
    fill: "#f2f2f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M975.96764,267.99007l5.60468-8.19146s20.69422,31.90358,18.9697,53.46005-3.449,22.41874-3.449,25.86777-4.3113,3.449,0,7.76033,10.3471,10.34711,6.89807,13.79615-6.03582,3.449-5.17356,7.76033a57.01212,57.01212,0,0,1,.86226,9.48484s-7.3292,14.22728-9.916,14.22728-27.16115,22.84986-27.16115,20.26308,2.58677-20.69421,2.58677-23.281.86226-11.20937,2.58678-13.79614,1.72452-1.72452,0-4.3113-1.72452,0-1.72452-2.58677.86226-6.03582-1.72451-6.89808-5.17356,0-3.449-4.31129,0-7.76033-.86226-7.76033-5.17355-.86226-2.58678-3.449-5.17355-52.59779-5.17355-52.59779S953.54891,280.924,975.96764,267.99007Z",
    transform: "translate(-69.34951 -42.79983)",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M971.22522,249.4515l14.6584,6.89807s20.69421,31.90358,18.9697,53.46006-3.449,22.41873-3.449,25.86777-4.31129,3.449,0,7.76033,10.34711,10.3471,6.89807,13.79614-6.03581,3.449-5.17355,7.76033a57.01228,57.01228,0,0,1,.86226,9.48485s-7.76033,41.38843-10.34711,41.38843-26.73-4.3113-26.73-6.89807,2.58678-20.69422,2.58678-23.281.86226-11.20936,2.58678-13.79614,1.72451-1.72452,0-4.31129-1.72452,0-1.72452-2.58678.86226-6.03581-1.72452-6.89807-5.17355,0-3.449-4.3113,0-7.76033-.86225-7.76033-5.17356-.86226-2.58678-3.449-5.17355-52.5978-5.17355-52.5978S948.80648,262.38539,971.22522,249.4515Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#575a89"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M840.38625,369.428a3.61426,3.61426,0,0,1-4.157-1.87589c-3.96236-7.92253-14.69832-31.1598-4.69-31.87468,9.233-.6595,17.45712,17.34443,20.8144,25.84817a4.10764,4.10764,0,0,1-2.77644,5.48372Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#ffb9b9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 820.82337,
    cy: 151.4671,
    r: 31.90358,
    fill: "#ffb9b9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M878.44971,175.893a62.85212,62.85212,0,0,1-12.26475,2.8953c-3.14212.49024-6.8191.74125-9.02744-1.54708-2.16719-2.24571-1.81659-5.99169-.33836-8.74028s3.84626-4.90348,5.62269-7.46945c2.79389-4.03565,4.44281-9.38581,8.91037-11.41883a16.3903,16.3903,0,0,1,5.79859-1.08311c11.59287-.73911,23.65963-1.405,34.3956,3.03117a25.31593,25.31593,0,0,1,10.382,7.38693,27.56767,27.56767,0,0,1,4.14985,8.04652,52.51278,52.51278,0,0,1-9.44766,50.42489c-3.91263-3.52517-2.211-11.67073-7.16171-13.467-1.62421-.58931-3.46031-.17922-5.124-.64571-5.22862-1.4661-4.966-9.54653-9.31879-12.79321a8.31294,8.31294,0,0,1-2.47865-2.0369,5.06594,5.06594,0,0,1-.48223-2.56887c-.03182-3.0271,1.39012-10.71635-1.49749-12.79123C887.62842,171.00411,881.27406,174.87307,878.44971,175.893Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "499.815 59 762.815 59 762.815 197 743.815 197 743.815 248 692.815 197 499.815 197 499.815 59",
    fill: "#536dfe"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M700.66488,200.3383l-4.64062-4.18631c-16.47969-15.13031-27.35938-24.95062-27.35938-37.18369a17.403,17.403,0,0,1,17.6-17.70693,18.9304,18.9304,0,0,1,14.4,6.76108,18.92968,18.92968,0,0,1,14.4-6.76108,17.403,17.403,0,0,1,17.6,17.70693c0,12.23323-10.87985,22.05354-27.35938,37.18369Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 397.522 252.994 325.668 290.697 458.418 272.42 463.609 286.354 512.669 223.36 477.543 37.703 530.272 0 397.522",
    fill: "#536dfe"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M222.76823,499.18465l-5.6078-2.75917C197.174,486.37323,184.02518,479.899,180.683,468.13133a17.403,17.403,0,0,1,12.09268-21.84175A18.93037,18.93037,0,0,1,208.475,448.8592a18.92962,18.92962,0,0,1,12.005-10.43808,17.403,17.403,0,0,1,21.76811,12.22475c3.34224,11.76781-4.44066,24.187-16.15951,43.24388Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M359.7858,359.91336s-8.55147,25.65442-3.80066,31.3554-28.5049-17.10295-28.5049-17.10295l18.05311-20.90359Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#a0616a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.93489,
    cy: 274.41126,
    r: 42.66057,
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "436.761 605.963 414.908 623.066 402.556 603.113 424.409 587.91 436.761 605.963",
    fill: "#a0616a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M475.23065,777.51019l5.701,27.55474,16.15278,21.85375s43.70752,13.30229,14.25245,19.95344-36.10621-4.75082-36.10621-4.75082l-20.90359-18.05311v24.70425H441.02477l-2.85049-35.156s-1.90033-10.4518,6.65114-21.85376l1.90033-17.10294Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M365.0117,436.40152,372.613,480.109s80.76389-8.55147,86.46487,7.6013,7.60131,20.9036,7.60131,20.9036l-16.15278,5.701-7.6013-14.25245a18.04661,18.04661,0,0,0-14.25245.95016c-7.60131,3.80065-74.11275,13.30229-78.86357.95016s-18.0531-57.96-18.0531-57.96l19.95343-16.15278Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#a0616a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M365.0117,436.40152,372.613,480.109s80.76389-8.55147,86.46487,7.6013,7.60131,20.9036,7.60131,20.9036l-16.15278,5.701-7.6013-14.25245a18.04661,18.04661,0,0,0-14.25245.95016c-7.60131,3.80065-74.11275,13.30229-78.86357.95016s-18.0531-57.96-18.0531-57.96l19.95343-16.15278Z",
    transform: "translate(-69.34951 -42.79983)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M409.66938,562.77325l6.65114,22.80393,17.10294,87.415s1.90033,64.61111,4.75082,72.21242,2.85049,8.55147,0,11.402-8.55147,12.35213,0,18.05311,38.9567,12.35212,39.90686,5.701.95017-17.10294,0-21.85376,2.85049-78.86357,2.85049-78.86357l-11.402-113.06944L430.573,548.5208Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M409.66938,562.77325l6.65114,22.80393,17.10294,87.415s1.90033,64.61111,4.75082,72.21242,2.85049,8.55147,0,11.402-8.55147,12.35213,0,18.05311,38.9567,12.35212,39.90686,5.701.95017-17.10294,0-21.85376,2.85049-78.86357,2.85049-78.86357l-11.402-113.06944L430.573,548.5208Z",
    transform: "translate(-69.34951 -42.79983)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M450.5264,473.45789,471.43,513.36476s119.72059,53.20915,109.26879,75.06291S512.287,651.13845,512.287,651.13845s-2.85049,16.15278-11.402,11.402S471.43,633.08535,473.33033,630.23486s8.55147-9.50164,11.402-8.55147,36.10621-24.70425,36.10621-24.70425l-57.00981-14.25245s-68.41176-1.90033-72.21242-34.20589,0-38.00653,0-38.00653l-4.75082-10.4518,38.95671-23.75409Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M479.98147,631.185,460.028,649.23813s-17.10294-7.60131-27.55474-4.75082-28.5049,4.75082-28.5049,4.75082l2.85049,16.15277,24.24231-4.4725-19.4915,27.27643s0,42.75735,12.35213,42.75735,8.55147-25.65441,8.55147-25.65441l38.00654-29.45507s19.00326-7.60131,20.90359-7.60131S479.98147,631.185,479.98147,631.185Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 286.63563,
    cy: 292.40928,
    r: 32.30556,
    fill: "#a0616a"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M324.15467,360.38844s15.20261-3.80065,19.95343,0,5.701,12.35213,12.35213,13.30229,12.35212.95017,13.30228,1.90033,22.80393,27.55474,22.80393,27.55474,13.30228,7.60131,16.15277,18.0531,31.3554,45.60785,35.15605,49.4085-24.70425,22.80392-34.20588,29.45507-37.05638,9.50163-45.60785-5.701S308.95205,380.34188,324.15467,360.38844Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#575a89"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M360.26088,422.14907l7.60131,43.70751s80.76389-8.55147,86.46487,7.60131,7.60131,20.9036,7.60131,20.9036l-16.15278,5.701L438.17428,485.81a18.04661,18.04661,0,0,0-14.25245.95016c-7.60131,3.80065-74.11275,13.30229-78.86357.95016s-18.0531-57.96-18.0531-57.96l19.95343-16.15277Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#a0616a"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M342.10343,364.38608s22.90827,48.26135,21.00794,61.56364-8.55147,3.80065-8.55147,3.80065-8.55147-13.30228-12.35213-5.701-8.55147,18.05311-12.35212,17.10295-24.70425-71.26226-13.30229-77.9134S342.10343,364.38608,342.10343,364.38608Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#575a89"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.71928,
    cy: 218.24152,
    r: 42.66057,
    fill: "#2f2e41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M257.27177,296.367A42.66289,42.66289,0,0,0,323.151,273.96669a42.66292,42.66292,0,1,1-83.21928-17.49478A42.64714,42.64714,0,0,0,257.27177,296.367Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 259.55875,
    cy: 281.52135,
    r: 31.28442,
    fill: "#2f2e41"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.86609,
    cy: 269.78968,
    rx: 27.72937,
    ry: 21.68579,
    fill: "#2f2e41"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.11072,
    cy: 295.73486,
    rx: 6.17606,
    ry: 10.92688,
    fill: "#a0616a"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M441.238,499.64724s16.82049-9.65037,19.94313-7.23052,4.51,9.992,4.51,9.992l-19.44046,7.63044-5.701-10.45179Z",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#2f2e41"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 291.73264,
    y1: 786.16036,
    x2: 291.73264,
    y2: 670.06684,
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.73264,
    cy: 670.06684,
    r: 16.41727,
    fill: "#3f3d56"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M361.08215,784.41751s-2.34533-50.44293-50.42446-44.57962",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#3f3d56"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 791.73264,
    y1: 700.16036,
    x2: 791.73264,
    y2: 584.06684,
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 791.73264,
    cy: 584.06684,
    r: 16.41727,
    fill: "#3f3d56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M861.08215,698.41751s-2.34533-50.44293-50.42446-44.57962",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#3f3d56"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 994.45926,
    y1: 702.81504,
    x2: 994.45926,
    y2: 470.62799,
    fill: "#3f3d56",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 994.45926,
    cy: 470.62799,
    r: 16.41727,
    fill: "#3f3d56"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.80876,580.288s2.34533-50.44293,50.42446-44.57962",
    transform: "translate(-69.34951 -42.79983)",
    fill: "#3f3d56"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.80876,741.10209s-10.55395-92.81816,50.42446-97.50881",
    transform: "translate(-69.34951 -42.79983)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1044.88372,
    cy: 600.79346,
    r: 16.41727,
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyloveBlue);
export default __webpack_public_path__ + "static/media/HappyloveBLUE.c6dad52f.svg";
export { ForwardRef as ReactComponent };